import HowItWorksSection from '../components/HowItWorksSection';

const HowItWorksPage = () => <HowItWorksSection />;

export default HowItWorksPage;